import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { BooxApiService } from './boox-api.service';

@Injectable({
  providedIn: 'root'
})
export class BooxEnvironmentService {

  constructor(
    private api : BooxApiService
  ) { }

  load() : Observable<any> {
    return this.api.get('/system/environment');
  }
}
